import { Icon } from '@teamsnap/snap-ui';
import { clsx } from 'clsx';
import * as React from 'react';

type InsightToggleTileProps = React.HTMLAttributes<HTMLDivElement> & {
  label: string;
  value: React.ReactNode;
  onToggle?: () => void;
  selected?: boolean;
};

export default function InsightToggleTile({
  label,
  value,
  onToggle,
  selected,
  ...props
}: InsightToggleTileProps) {
  return (
    <article {...props}>
      <p
        data-testid="InsightToggleTile__label"
        className="sui-text-desktop-2 sui-text-neutral-text-medium sui-uppercase sui-mb-1"
      >
        {label}
      </p>
      <div
        data-testid="InsightToggleTile__value"
        className="sui-flex sui-gap-[6px] sui-items-center"
      >
        <p className="sui-text-desktop-8 sui-font-bold">{value}</p>
        {/* This temp Local Toggle will be replaced by the new Toggle component from SnapUI once is ready */}
        {onToggle && (
          <button
            onClick={onToggle}
            className={clsx(
              'sui-border sui-border-solid sui-rounded sui-flex sui-place-content-center sui-h-[24px] sui-w-[24px] sui-text-neutral-text-medium sui-cursor-pointer',
              {
                'sui-bg-white sui-border-neutral-border': !selected,
                'sui-bg-action-background sui-text-white sui-border-action-background':
                  selected,
              }
            )}
          >
            <Icon name="filter_alt" size="s" />
          </button>
        )}
      </div>
    </article>
  );
}
